import Head from "next/head";
import { useState } from "react";
import { Col, Grid, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import PublicFooter from "../components/Footer/PublicFooter";
import PublicHeader from "../components/Header/PublicHeader";
import PublicMobileHeader from "../components/Header/PublicMobileHeader";
import MobileMenu from "../components/Menus/MobileMenu";
import SlideIn from "../components/SlideIn";
import { device } from "../theme/Breakpoints";
import PublicStyles from "../theme/PublicStyles";
import ThemeProvider from "../theme/ThemeProvider";

const StyledContentWrapper = styled(Row)`
  margin: 86px 0 0 0;

  @media (max-width: 1152px) {
    margin: 66px 0 0 0;
  }
`;

const StyledCol = styled(Col)`
  min-height: calc(100vh - 86px - 110px);
  @media ${device.smAndWider} {
    min-height: calc(100vh - 60px - 350px);
  }
`;

const Public = (props) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
        />
        <title>{props.title}</title>
      </Head>

      <PublicStyles />

      <ThemeProvider>
        <Grid fluid={true}>
          <SlideIn
            direction="fromTop"
            visible={showMobileMenu}
            setVisible={setShowMobileMenu}
            data-cy="profile-switcher-menu"
          >
            <MobileMenu setShowMenu={setShowMobileMenu} />
          </SlideIn>

          <Row>
            <Col xs={false} md={12}>
              <PublicHeader />
            </Col>
            <Col xs={12} md={false}>
              <PublicMobileHeader
                showMenu={showMobileMenu}
                setShowMenu={setShowMobileMenu}
              />
            </Col>
          </Row>
          <StyledContentWrapper>
            <StyledCol xs={12}>{props.children}</StyledCol>
          </StyledContentWrapper>

          <PublicFooter />
        </Grid>
      </ThemeProvider>
    </>
  );
};

export default Public;
